
import type { Localizations } from '../..';



export const catalogLocalizations: Localizations = {

};
